import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconRefreshOutline } from '@icons/IconRefreshOutline'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import { getComponentHeights } from '../utils'

const CAN_REFRESH = true

export function ChartBarEmptyResponse({
  title,
  description,
  tileFilters,
  reloadHandler,
  emphasizeHeader,
}: {
  title?: string
  description?: string
  tileFilters?: React.ReactNode
  reloadHandler?: () => void
  emphasizeHeader?: boolean
}) {
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)

  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>
            {CAN_REFRESH && reloadHandler && (
              <TooltipButton tooltip="Refresh data">
                <Button size="icon" variant="ghost" className="size-8 rounded-full" onClick={reloadHandler}>
                  <IconRefreshOutline className="size-4" />
                </Button>
              </TooltipButton>
            )}
            {tileFilters}
          </ComponentActionsContainer>
        </ComponentHeader>
      )}
      <div
        className="flex flex-1 items-center justify-center text-sm text-muted-foreground"
        style={{ height: contentHeight }}
      >
        No data available
      </div>
    </div>
  )
}
